import type { Squad } from '../../../types';

const DAY_CODES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] as const;

export function dayCodeForYmd(value: string): string | undefined {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return undefined;
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  if (Number.isNaN(date.getTime())) return undefined;
  return DAY_CODES[date.getUTCDay()];
}

export function normalizedSingleDaySchedule(
  schedule: Squad['schedule'] | undefined,
): Squad['schedule'] {
  const mainDate = String(schedule?.mainDate || schedule?.startDate || schedule?.endDate || '').slice(0, 10);
  if (!mainDate) return { ...(schedule || {}) };
  return {
    ...(schedule || {}),
    mainDate,
    startDate: mainDate,
    endDate: mainDate,
    dayOfWeek: dayCodeForYmd(mainDate),
    exceptions: [],
    makeups: [],
  };
}

export function effectiveScheduleDate(squad: Partial<Squad>, side: 'start' | 'end' = 'start'): string {
  return String(
    squad.schedule?.mainDate
      || (side === 'start' ? squad.schedule?.startDate : squad.schedule?.endDate)
      || '',
  ).slice(0, 10);
}
